<app-data-set
	#dataSet
	[dataSource]="dataSource"
	[selectedDisplayFormat]="formatSelectedUserName"
	[rowId]="rowId"
	[enablePersistentSelection]="true"
>
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="email"
				[defaultFilterLabel]="filterLabels.email"
				[placeholder]="filterLabels.defaultPlaceholder"
			>
				<div class="filter-grid" [style.--columns]="3">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.firstName }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('firstName')"
								data-automation-id="first-name-input"
								(ngModelChange)="dataSet.filter('firstName', filterLabels.firstName, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.lastName }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('lastName')"
								data-automation-id="last-name-input"
								(ngModelChange)="dataSet.filter('lastName', filterLabels.lastName, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.email }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('email')"
								data-automation-id="email-input"
								(ngModelChange)="dataSet.filter('email', filterLabels.email, $event)"
							/>
						</mat-form-field>
					</div>
				</div>
			</app-data-set-search>
		</div>
		@if (canAddUser()) {
			<div *appActionGroup>
				<app-data-set-action-button
					icon="add"
					label="Add"
					(click)="navigateToAddUsers()"
					data-automation-id="add-users-button"
					i18n-label="@@roleDetailUserTable-add"
				></app-data-set-action-button>
			</div>
		}

		@if (canAddUser()) {
			<div *appSelectedActionGroup>
				<app-data-set-action-button
					class="destructive"
					icon="clear_icon"
					[label]="
						dataSet.selection.selected.length > 1
							? userDeactivationLabels.pluralUsers
							: userDeactivationLabels.singularUser
					"
					i18n-label="@@roleDetailUserTable-removeUsers"
					data-automation-id="remove-users-button"
					(click)="removeUsers(selectedUsers)"
				>
				</app-data-set-action-button>
			</div>
		}
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (loadingService.isLoading(getAssignedRoleUsersLoadingKey) || !finishedLoadingInitData) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="loadingService.isLoading(getAssignedRoleUsersLoadingKey) || !finishedLoadingInitData"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				<ng-container matColumnDef="rowSelection">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row">
						@if (canRemoveUser(row)) {
							<app-data-set-table-row-selection [data]="row"></app-data-set-table-row-selection>
						}
					</td>
				</ng-container>

				<ng-container matColumnDef="firstName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@roleDetailUserTable-firstName">First Name</th>
					<td mat-cell *matCellDef="let row">{{ row.firstName }}</td>
				</ng-container>

				<ng-container matColumnDef="lastName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@roleDetailUserTable-lastName">Last Name</th>
					<td mat-cell *matCellDef="let row">{{ row.lastName }}</td>
				</ng-container>

				<ng-container matColumnDef="email">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@roleDetailUserTable-email">Email</th>
					<td mat-cell *matCellDef="let row">{{ row.email }}</td>
				</ng-container>

				<ng-container matColumnDef="phoneNumber">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@roleDetailUserTable-phoneNumber">
						Phone Number
					</th>
					<td mat-cell *matCellDef="let row">{{ row.phoneNumber | phoneNumber }}</td>
				</ng-container>

				<ng-container matColumnDef="active">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@roleDetailUserTable-detailStatus">Status</th>
					<td mat-cell *matCellDef="let row">
						@if (row.active && row.verified !== false) {
							<span i18n="@@roleDetailUserTable-active">Active</span>
						}
						@if (row.verified === false) {
							<span i18n="@@roleDetailUserTable-pending">Pending</span>
						}
					</td>
				</ng-container>

				<ng-container matColumnDef="rowMenu">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row">
						@if (canRemoveUser(row)) {
							<app-data-set-table-menu [menu]="menu" [row]="row"></app-data-set-table-menu>
						}
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					(appDataSetRowClick)="onRowClick(row)"
					[attr.data-automation-id]="'role-detail-user-' + row.id + '-row'"
				></tr>
			</table>

			<mat-menu #menu="matMenu" class="hamburger-menu-container">
				<ng-template matMenuContent let-row="row">
					<button
						mat-menu-item
						(click)="removeUsers([row])"
						data-automation-id="deactivate-user-button"
						i18n="@@roleDetailUserTable-deactivateUserMenuButton"
					>
						Deactivate User
					</button>
				</ng-template>
			</mat-menu>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
